export function toRoute(href: string): string {
  if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) return href;
  try {
    const url = new URL(href, window.location.origin);
    if (url.origin !== window.location.origin) return href;
    if (url.pathname === '/index.html') url.pathname = '/';
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return href;
  }
}

export function isInternalHref(href?: string): boolean {
  if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) return false;
  try { return new URL(href, window.location.origin).origin === window.location.origin; }
  catch { return false; }
}
